import { formatNumber } from "./format-number";

/**
 * Formats a time value with "s" unit suffix
 * @param value - Time value in seconds (can be null or undefined)
 * @returns Formatted string with unit, or "-" if value is null/undefined
 */
export function formatTime(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return "-";
  }
  return `${formatNumber(value)}s`;
}








